import type { UseFormSetValue } from 'react-hook-form';
import { useEffect, useRef } from 'react';
import type {
  IntegrationRequestFormOptions,
  IntegrationRequestFormSchema,
} from '../../../models/IntegrationRequest';

interface UseSingleOperatorPreselectionProps {
  options?: IntegrationRequestFormOptions;
  enabled: boolean;
  setValue: UseFormSetValue<IntegrationRequestFormSchema>;
}

const useSingleOperatorPreselection = ({
  options,
  enabled,
  setValue,
}: UseSingleOperatorPreselectionProps) => {
  const applied = useRef(false);

  useEffect(() => {
    if (applied.current || !options) return;
    applied.current = true;
    if (enabled && options.logisticOperators.length === 1) {
      setValue('logisticOperatorId', options.logisticOperators[0].id);
    }
  }, [options, enabled, setValue]);
};

export default useSingleOperatorPreselection;
